<template>
  <main class="winners bb">
    <section>
      <PageBackButton />

      <h1 class="pg_title">{{ $_translations.value.page_winners_public_title }}</h1>
      <h2 class="subtitle">{{ $_translations.value.page_winners_public_subtitle }}</h2>
    </section>

    <div v-if="error" class="error-state">
      {{ error }}
    </div>

    <template v-else-if="winnersLoaded">
      <WinnersPublicPrizeSection
        v-for="prizeType in availablePrizeTypes"
        :key="prizeType"
        :prize-type="prizeType"
        :winners="winnersListPerType[prizeType]"
        :last-updated="lastUpdated.date"
        :is-expanded="expandedSections[prizeType]"
        :max-initial-winners="2"
        @toggle-expansion="toggleExpansion"
      />
    </template>
  </main>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import useWinnersStore from '@/store/modules/winners.js';
import { prizeTypeEnum } from '@/constants/winners.js';
import PageBackButton from '@/components/button/PageBackButton.vue';
import WinnersPublicPrizeSection from './components/section/WinnersPublicPrizeSection.vue';

const winnersStore = useWinnersStore();
const winnersLoaded = ref(false);
const error = ref(null);
const { proxy } = getCurrentInstance();

// Destructure store properties
const {
  winnersListPerType,
  lastUpdated,
  expandedSections,
  dispatchRetrieveWinners,
  toggleExpansion,
} = winnersStore;

// Define the order of prize types to display
const availablePrizeTypes = computed(() => [
  prizeTypeEnum.GRAND,
  prizeTypeEnum.MONTHLY,
  prizeTypeEnum.WEEKLY,
]);

// Load winners on component mount
onMounted(async () => {
  try {
    await dispatchRetrieveWinners();
    winnersLoaded.value = true;
  } catch {
    error.value = proxy.$_translations.page_winners_public_error_loading_winners;
  }
});
</script>
